import { Component } from '@angular/core';
import { User } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user/user.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent {
  dtoptions: DataTables.Settings = {};
  users: User[] = []

  constructor(private userService: UserService, private router: Router) { }

  navigate(TId){
    console.log(TId);
    var id = btoa(TId.toString())
    this.router.navigate(['/component/user/edit/' + id]);
  }
  
  ngOnInit(): void {
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if (loggedInuserRole.role == 'Standard User' || loggedInuserRole.role == 'Internal User' || loggedInuserRole.role == 'Regional User') {
      //this.router.navigate(['/']);
      this.logout();
    }
    this.dtoptions = {
      pagingType: 'full_numbers'
    };
    this.userService.getAllUser()
      .subscribe({
        next: (users) => {
          this.users = users;
          // console.log(users);
        },
        error: (response) => {
          console.log(response);

        }
      })
  }
  logout() {
    sessionStorage.clear();
    this.router.navigate(['login']);
  }
}
